<template>

<div class=" w-full h-full font-euclid">

  <!-- NAV BAR SECTION -->
      <nav class="sticky w-full z-40 top-0 " >

    <navBar/>

    </nav>

  <div class="bg-[#e8e6fe]">
    <div class=" mx-auto text-black text-2xl font-medium ">Set Medication Reminder</div>


    <div
    v-if="success"
    class=" border w-9/12 mx-auto bg-medalertBlue bg-opacity-10  text-black px-4 py-3 mt-6 rounded relative"
    role="alert">

        <!-- <strong class="font-bold mx-2">Thank you!</strong> -->
        <span class="">{{ success }}</span>
    </div>

    <div
    v-if="err"
    class=" border w-9/12  mx-auto bg-red  text-white px-4 py-3 mt-6 rounded relative"
    role="alert">

        <!-- <strong class="font-bold mx-2">Thank you!</strong> -->
        <span class="">{{ err }}</span>
    </div>


      <div class="w-9/12 mx-auto text-left relative">

        <form @submit.prevent="handleReview" class="w-full h-full mt-8  bg-white pb-32 border-b-4">

          <h1 class="bg-gray-200 py-2 px-8 text-black ">Patient Details</h1>

          <div class="mt-6 px-4 text-black  mx-4 my-10 flex justify-between">

            <div>
             <label class="font-semibold text-base mb-2 w-full" for="">Phone number</label>
              <div class="flex flex-row align-middle w-full mb-2 mt-2 ">
              <div class="flex flex-col text-start  ">
                <select v-model="countryCode" required id="country_code"   class=" border-r-transparent rounded-l-md form-control block px-3 py-2.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-400 roundedtransition ease-in-out m-0
                focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none">
                <option selected :value="234">+234</option>
                </select>
                <!-- <div v-if="!countryCode  && buttonClicked" class="text-red text-sm" >Select Code</div> -->
              </div>

              <div class="flex flex-col text-start">
                  
                  <input v-model="phoneNumber" 
                  @keyup="getCustomerDemography"
                  type="number"
                  required
                   class=" rounded-r-md  form-control block px-3 py-2 text-base font-normal text-gray-700
                  bg-white bg-clip-padding  border-solid border-gray-400 roundedtransition ease-in-out m-0
                  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none border-2" placeholder="Phone number"
                  >
                  <!-- <div v-if="!phoneNumber && buttonClicked" class="text-red text-sm" >Enter phone number</div> -->
              </div>
              </div>
            </div>

            <div>
             <label class="font-medium text-gray-600 mb-2 w-full" for="">Gender</label>
              <div class="flex flex-row align-middle w-full mb-2 mt-2 ">
                <div class="flex flex-col text-start  ">
                  <select v-model="gender"  id="gender"   class=" rounded-md form-control block px-3 py-2.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-400 roundedtransition ease-in-out m-0
                  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none">
                  <option selected value="Male">Male</option>
                  <option value="Female">Female</option>
                  </select>
                  <!-- <div v-if="!countryCode  && buttonClicked" class="text-red text-sm" >Select Code</div> -->
                </div>

              </div>
            </div>

            <div>
             <label class="font-medium text-gray-600 mb-2 w-full" for="">Date of Birth</label>
              <div class="flex flex-row align-middle w-full mb-2 mt-2 ">
                <div class="flex flex-col text-start  ">
                  <input  v-model="dob" type="date"  min=""  :max="currentDate" pattern=""  class=" rounded-md  form-control block px-3 py-2 text-base font-normal text-gray-700
                      bg-white bg-clip-padding border border-solid border-gray-400 roundedtransition ease-in-out m-0
                      focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" >
                  <!-- <div v-if="!countryCode  && buttonClicked" class="text-red text-sm" >Select Code</div> -->
                </div>

              </div>
            </div>

            <div>
             <label class="font-medium text-gray-600 mb-2 w-full" for="">Note or Diagnosis</label>
              <div class="flex flex-row align-middle w-full mb-2 mt-2 ">
                <div class="flex flex-col text-start  ">
                  <input  v-model="note" type="text"  class=" rounded-md  form-control block px-3 py-2 text-base font-normal text-gray-700
                      bg-white bg-clip-padding border border-solid border-gray-400 roundedtransition ease-in-out m-0
                      focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" >
                  <!-- <div v-if="!countryCode  && buttonClicked" class="text-red text-sm" >Select Code</div> -->
                </div>

              </div>
            </div>
           
          </div>

          <h1 class="bg-gray-200 py-2 px-8 text-black mb-2  ">Dosage Details</h1>

          <div class="flex flex-col" v-for="(dosageDetail,i) in dosageDetails" :key="i"> 

            <!-- <button @click.prevent="deleteDosageDetail(i)" class="mx-8 flex mt-4  text-medalertOrange font-normal cursor-pointer absolute right-0">
             <div class="right-0"> <i class="ri-close-fill "></i></div>
              Delete
            </button> -->

        
            <div class="mt-4 px-4 text-black  mx-4 flex justify-between">

              <div class="flex flex-col text-start mb-2 ">
                    <label class="font-semibold text-base mb-2" for="">Drug name</label>

                    <input list="allDrugs" required  type="text" id="search"  v-model="dosageDetail.drugNameObject"  class=" rounded-md  form-control block px-3 py-2 text-base font-normal text-gray-700
                    bg-white bg-clip-padding border border-solid border-gray-400 roundedtransition ease-in-out m-0
                    focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" placeholder="Enter drug name" >

                    <datalist id="allDrugs">
                      <option v-for="(drugNames, index) in allDrugs" :key="index">{{drugNames.name}}</option>
                    </datalist>

                    <!-- <div v-if="!dosageDetail.drugNameObject && buttonClicked" class="text-red text-sm" >Enter drug</div> -->
              </div> 


              <div class="flex flex-col text-start ">
                    <label class="font-semibold text-base mb-2" for="">Dose</label>
                    <select id="frequency"  class=" rounded-md  form-control block px-3 py-2 text-base font-normal text-gray-700
                    bg-white bg-clip-padding border border-solid border-gray-400 roundedtransition ease-in-out m-0
                    focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" placeholder="Enter drug name" 
                    v-model="dosageDetail.dose">
                    <option :value="null" selected disabled>Select Dose</option>
                    <option  v-for="frequency in frequencies" :value="frequency.value" :key="frequency.value">{{frequency.freq}}</option>
                    </select>
                    <!-- <div v-if="!dosageDetail.dose && buttonClicked" class="text-red text-sm" >Select dose</div> -->
              </div>

              
              <div class="flex flex-col text-start" >
                <label class="font-semibold text-base mb-2" for="">Duration</label>
                <div class="flex flex-row align-middle w-full  ">
                    <div class="flex flex-col text-start  ">
                      <select required  id="country_code"  class=" border-r-transparent rounded-l-md form-control block px-3 py-2 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-400 roundedtransition ease-in-out m-0
                      focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"  
                      v-model="dosageDetail.durationObject">
                      <option selected :value="1" >1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                      <option value="13">13</option>
                      <option value="14">14</option>
                      </select>
                      <!-- <div v-if="!dosageDetail.durationObject && buttonClicked" class="text-red text-sm" >Select duration</div> -->
                    </div>

                    <div class="flex flex-col text-start ">
                        
                        <select   class=" rounded-r-md  form-control block px-3 py-2 text-base font-normal text-gray-700
                        bg-white bg-clip-padding border border-solid border-gray-400 roundedtransition ease-in-out m-0
                        focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none">
                        <option selected value="day">Day(s)</option>
                        </select>
                    </div>
                </div>
              </div>

              <div class="flex flex-col text-start mb-2 ">
                    <label class="font-semibold text-base mb-2" for="">Start on</label>
                    <div class="flex">
                        <input required v-model="dosageDetail.startDate" type="date"  :min="currentDate"  max="" pattern=""  class=" rounded-md  form-control block px-3 py-2 text-base font-normal text-gray-700
                      bg-white bg-clip-padding border border-solid border-gray-400 roundedtransition ease-in-out m-0
                      focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" >

                      <i @click.prevent="deleteDosageDetail(i)" class="ml-6 ri-delete-back-2-line text-2xl text-medalertOrange cursor-pointer "></i>
                    </div>
                    <!-- <div v-if="!dosageDetail.startDate && buttonClicked" class="text-red text-sm" >Select start date</div> -->
              </div>
             
            </div>

          </div> 

          <button @click.prevent="addMoreDosageDetails" class="mx-8 flex text-medalertBlue font-normal cursor-pointer">

              <i class="ri-add-fill "></i>
              Add More

          </button>
          
            
          <div class="flex flex-row mx-auto justify-center mt-8">

            <div class="text-black bg-white border-2 mt-5 mr-3 mb-3 text-center rounded-md font-euclid font-medium text-sm  hover:bg-medalertOrange hover:text-white">
              <button @click="handleCancle"  class=" py-2 w-24 ">Cancel</button>
            </div>
            <div class="">
              <button
              :class="inactive ? 'cursor-not-allowed' : ''"
              :disabled="inactive" class="bg-medalertBlue disabled:bg-gray-200  w-24 py-2 border-2 mt-5 mr-3 mb-3 text-center text-white  font-euclid font-medium rounded-md text-sm"  type="submit">
                 Review 
              </button>
            </div>

            
          
          </div>


        </form> 

              
      </div>
  </div>

</div>
 




</template>



<script>

import { ref } from 'vue'
import {useRouter} from 'vue-router'
import { useStore } from "vuex";
import axios from 'axios';

import navBar from '../components/NavBar'
import Loading from "../components/Loading";

import { ModelSelect } from 'vue-search-select'


import Vue from "vue";
import vSelect from "vue-select";

// import Datepicker from 'vuejs-datepicker';
// import VueCtkDateTimePicker from "vue-ctk-date-time-picker";





export default {

  components:{Loading, ModelSelect, vSelect, navBar },


  setup(){

    const router = useRouter()
    const store = useStore();

   
    

    const success = ref('');
    const err = ref('');
    const inactive = ref(false);

    const isLoading = ref(false);


    const today = new Date().toISOString().slice(0, 10);
    console.log(today)
    const currentDate = ref(today);

    const allDrugs = ref([])

    const currentPhoneNumber = JSON.parse(localStorage.getItem('phoneNumber')) || ''
    const enteredPhoneNumber = currentPhoneNumber || null
    console.log(currentPhoneNumber)

    const phoneNumber = ref(enteredPhoneNumber)
    const countryCode = ref("234");

    const gender = ref("");
    const dob = ref("");
    const note = ref("");

    const customerDemography = ref({})

    

    


    // const currentDate = String(getDate.getDate()).padStart(2, '0')
    // const currentMonth = String(getDate.getMonth()).padStart(2, '0')
    // const currentYear = getDate.getFullYear()

    const currentDosageData = JSON.parse(localStorage.getItem('dosageDetails')) || []
    console.log(currentDosageData)

  let enteredDosageDetails 
   
    //console.log(enteredDosageDetails)

    // enteredDosageDetails.forEach(element => {
      
    // });

    let emptydosageDetails = {
      drugNameObject: enteredDosageDetails?.drugNameObject || null,
      durationObject: enteredDosageDetails?.durationObject || 1,
      dose: enteredDosageDetails?.dose || null,
      startDate: enteredDosageDetails?.startDate || null,
    };
    

    let dosageDetails = ref([])
    console.log(currentDosageData)
    if (currentDosageData.length > 0) {
      console.log("test")
        currentDosageData.forEach(item => {
          emptydosageDetails = {
      drugNameObject: item?.drugNameObject || null,
      durationObject: item?.durationObject || 1,
      dose: item?.dose || null,
      startDate: item?.startDate || null,
      
    };
      //dosageDetails =   ref([{ ...emptydosageDetails }])
      dosageDetails.value = [
        ...dosageDetails.value,
        {
          ...emptydosageDetails
        },
      ]
     })
    }else {
      console.log("test else")
      dosageDetails =   ref([{ ...emptydosageDetails }]);
    }
  


    const deleteDosageDetail = (index) => {
      dosageDetails.value.splice(index, 1);
    };

    const addMoreDosageDetails = () => {
      dosageDetails.value = [
        ...dosageDetails.value,
        {
          ...emptydosageDetails
        },
      ]
    }

    const handleCancle = () => {
      router.push('/dashboard');
      window.localStorage.dosageDetails = JSON.stringify([]);
      window.localStorage.phoneNumber = JSON.stringify(null);
    };

    const handleReview = async () => {
      try {
        inactive.value = true
        isLoading.value = true;
        let completePhone =  countryCode.value + phoneNumber.value
        localStorage.setItem('phoneNumber', JSON.stringify(phoneNumber.value))  
        console.log(currentPhoneNumber)
        if (dosageDetails.value.length > 0){
          store.commit("createPrescriptions", dosageDetails.value);
          store.commit("clientPhone", completePhone);
          store.commit("gender", gender.value);
          store.commit("dob", dob.value);
          store.commit("note", note.value);
          localStorage.setItem('dosageDetails', JSON.stringify(dosageDetails.value))  
          console.log(currentDosageData)
          await store.dispatch( 'createReminder', {
          phone_number: completePhone,
          language:'ENGLISH',
          gender: gender.value,
          note: note.value,
          date_of_birth: dob.value,
          items: dosageDetails.value.map((dosageDetail) => ({
            drug_name: dosageDetail.drugNameObject,
            no_of_days: dosageDetail.durationObject,
            dose: dosageDetail.dose,
            start_time: dosageDetail.startDate
          }))
          
        })
        console.log(gender.value, note.value, dob.value)
        inactive.value = false
        } else {
          return;
        }
      
        isLoading.value = false;
      } 
      catch(error){
        inactive.value = false
        err.value = error.response?.data?.message ?? "Cannot initiate reminder";
        console.log(error)
        setTimeout(() => {
          err.value = "";
          }, 3000);  

      }
    }


    const getAllDrugs = async () => {
      try{
        const response = await axios.get(`/api/v1/drugs/approved`)
        // console.log(response.data.data) 
        const drugListObject = response.data.data
        // for (let i = 0; i < drugListObject.length; i++){
          allDrugs.value = drugListObject
          console.log(allDrugs.value)
        // }
      } catch(error){
        console.log(error)
      }
    };

    const getCustomerDemography = async () => {
      try{
        let completePhone =  countryCode.value + phoneNumber.value
        
         if(completePhone.length === 13){
          const response = await axios.get(`/api/v1/prescriptions/${completePhone}/phone`)
          console.log(response)
          gender.value = response.data.data.gender
          dob.value = response.data.data.date_of_birth
         }
         if(completePhone.length != 13){
            gender.value = "";
            dob.value = "";
          }
        
      } 
      catch(error){
      console.log(error)
      } 
    }



    
    return{
      dosageDetails,
      phoneNumber,
      countryCode,
      gender,
      dob,
      note,
      success,
      err,
      today,
      isLoading,
      inactive,
      allDrugs,
      currentDosageData,
      currentPhoneNumber,
      currentDate,
      today,
      customerDemography,
      addMoreDosageDetails,
      deleteDosageDetail,
      handleCancle,
      handleReview,
      getAllDrugs,
      getCustomerDemography
      
    }
  },
  

  


  

  data(){
      return{
        drugName: [],

        frequencies: [
        {value: '', freq: 'none'},
        {value: 'I', freq: 'I'},
        {value: 'I - I', freq: 'I - I'},
        {value: 'II - II', freq: 'II - II'},
        {value: 'I -I -I', freq: 'I - I - I'},
        {value: 'II - I - I', freq: 'II - I - I'},
        {value: 'II - I - II', freq: 'II - I - II'},
        {value: 'II - II - II', freq: 'II - II - II'}
        
        ]
      
      }
  },
  
  mounted(){
      this.getAllDrugs();
      // this.getCustomerDemography();
    }


}
</script>

<style>

</style>